export default "__VITE_ASSET__C4X_Hfr6__"